import apiUrl from '../baseUrls/functions';
import AxiosService from '../axiosConfig/AxiosService';

export default new class TypeTiersService {

    get = (callback, queryParams) => AxiosService.get(apiUrl('/api/crud/type-tiers/get'), callback, queryParams);
    getById = (id, callback) => AxiosService.get(apiUrl(`/api/crud/type-tiers/get/${id}`), callback);
    add = (data, callback) => AxiosService.post(apiUrl('/api/crud/type-tiers/add'), data, callback);
    update = (data, callback) => AxiosService.put(apiUrl('/api/crud/type-tiers/update'), data, callback);
    delete = (id, callback) => AxiosService.delete(apiUrl(`/api/crud/type-tiers/delete/${id}`), callback);
   

}